import { Button, Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';
import { BottomButtonWrapper } from '../../../../common/components/BottomButtonWrapper';

interface CtaButton {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  /** mutation pending 중 스피너 — 중복 호출 방지(더블탭). (SID-4740) */
  loading?: boolean;
}

interface SeedingFloatingActionBarProps {
  mode: 'single' | 'dual';
  primary: CtaButton;
  /** mode='dual' 일 때만 사용. 좌측 secondary 버튼 */
  secondary?: CtaButton;
  /** propose-07 의 backdrop-blur 변형 */
  variant?: 'default' | 'blur';
  className?: string;
}

export const SeedingFloatingActionBar = ({
  mode,
  primary,
  secondary,
  variant = 'default',
  className,
}: SeedingFloatingActionBarProps) => (
  <BottomButtonWrapper
    // data-cta-area — mds-ui Snackbar 의 useCTAHeight 가 이 selector 를 ResizeObserver
    // 로 감지해 toast bottom offset 을 자동 조정. 미부착 시 snackbar 가 CTA 를 가림.
    data-cta-area
    className={twMerge(
      // sticky 유지 — BottomButtonWrapper 가 자체적으로 `sticky bottom-0` 처리.
      // fixed 로 override 하면 본문 가림 → pb-72 보정 필요 → 관리 복잡. sticky 로 본문 흐름 안 깨짐.
      'py-[12px]! z-20',
      variant === 'blur' && 'backdrop-blur-md bg-white/80',
      className,
    )}
  >
    {mode === 'dual' && secondary ? (
      <div className="flex gap-[8px]">
        <Typography size="14" weight="medium" asChild>
          <Button
            variant="secondary"
            className="w-1/2"
            onClick={secondary.onClick}
            disabled={secondary.disabled}
            isLoading={secondary.loading}
          >
            {secondary.label}
          </Button>
        </Typography>
        <Typography size="14" weight="medium" asChild>
          <Button
            variant="primary"
            className="w-1/2"
            onClick={primary.onClick}
            disabled={primary.disabled}
            isLoading={primary.loading}
          >
            {primary.label}
          </Button>
        </Typography>
      </div>
    ) : (
      <Typography size="14" weight="medium" asChild>
        <Button
          variant="primary"
          className="w-full"
          onClick={primary.onClick}
          disabled={primary.disabled}
          isLoading={primary.loading}
        >
          {primary.label}
        </Button>
      </Typography>
    )}
  </BottomButtonWrapper>
);
